const SummaryDeletionReasons = {
  SANDFIRE: 'SANDFIRE_DELETION',
} as const;

export const CSA_SUMMARIES = 'CSA Summaries';
export const CSA_SUMMARIES_SLOT = 'csa_summaries';

export { SummaryDeletionReasons };
